import React, {useEffect, useRef, useState} from "react";
import { usePopper } from "react-popper";
import SignOut from "../auth/SignOut";
import {NavLink} from "react-router-dom";
import {FiUser} from "react-icons/all";
import MetaMaskOnboarding from '@metamask/onboarding';
import Web3 from 'web3';

const Profile = (props) => {
    const [dropdownPopoverShow, setDropdownPopoverShow] = useState(false);
    const btnDropdownRef = useRef(null);
    const popoverDropdownRef = useRef(null);
    const [metamaskTxt, setMetamaskTxt] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [balance, setBalance] = useState('0');
    let web3;

    const { styles, attributes } = usePopper(
        btnDropdownRef.current,
        popoverDropdownRef.current,
        {
            placement: "bottom-start",
            modifiers: [
                {
                    name: "offset",
                    enabled: true,
                    options: {
                        offset: [0, 10],
                        closeOnClickOutside: true
                    }
                }
            ]
        }
    );

    useEffect(() => {
        web3 = new Web3();
        if (isMetaMaskInstalled()) {

            // if (isMetaMaskConnected()) {
            //     setMetamaskTxt("Connected");
            //     web3 = new Web3(window.ethereum);
            //     getTraleBalance();
            // } else {
                setMetamaskTxt("Connect Wallet");
            // }
        } else {
            setMetamaskTxt("Install MetaMask");
        }

        // listen for clicks and close dropdown on body
        document.addEventListener("mouseup", handleDocumentClick);
        return () => {
            document.removeEventListener("mouseup", handleDocumentClick);
        };
    }, []);

    /**
     POPOVER METHODS
     **/
    function handleDocumentClick(event) {
        if (btnDropdownRef.current.contains(event.target)) {
            return;
        }
        setDropdownPopoverShow(false);
    }
    function handleDropdownClick(event) {
        setDropdownPopoverShow(!dropdownPopoverShow);
    }

    /**
        METAMASK METHODS
    **/

    const ethEnabled = async () => {

        // Instance web3 with the provided information from the MetaMask provider information
        web3 = new Web3(window.ethereum);
        try {
            // Request account access
            // await window.ethereum.enable();
            const accounts = await window.ethereum.request({method: 'eth_requestAccounts'})
                .then((accounts) => {
                    console.log(accounts);
                    getTraleBalance(accounts);
                })
                .catch((error) => console.error(error));
            return true
        } catch (e) {
            // User denied access
            return false
        }

    }

    const isMetaMaskConnected = async () => {
        try {
            const accounts = await window.ethereum.request({method: 'eth_requestAccounts'});
            setAccounts(accounts);
            return true;
        } catch (error) {
            return false;
        }
    }

    const isMetaMaskInstalled = () => {
        const { ethereum } = window
        return Boolean(ethereum && ethereum.isMetaMask)
    }

    function connectToMetaMask() {
        if (isMetaMaskInstalled()) {
            console.log('MetaMask is installed!');
            const ethereumButton = document.getElementById('connectEthereumButton');
            if (ethereumButton) {
                onClickConnect().then(() => setMetamaskTxt("Connected"));
            } else {
                console.log('No button!');
            }
        } else {
            onClickInstall();
        }

    }

    const onClickConnect = async () => {
        try {
            // Will open the MetaMask UI
            // You should disable this button while the request is pending!
            // const newAccounts = await ethereum.request({ method: 'eth_requestAccounts' });
            web3 = new Web3(window.ethereum);
            const newAccounts = await web3.eth.getAccounts();
            console.log("Accounts", newAccounts);
            if (newAccounts !== null && newAccounts.length > 0) {
                setAccounts(newAccounts);
                await getTraleBalance(newAccounts);
            } else {
                await ethEnabled();
            }

        } catch (error) {
            console.error(error);
        }
    };

    const getTraleBalance = async (acc) => {
        try {
            console.log("newAccounts", acc);

            // if (await !ethEnabled()) {
            //     alert("Please install MetaMask to use this dApp!");
            // }

            // const minABI = [
            //     // balanceOf
            //     {
            //         constant: true,
            //         inputs: [{ name: "_owner", type: "address" }],
            //         name: "balanceOf",
            //         outputs: [{ name: "balance", type: "uint256" }],
            //         type: "function",
            //     },
            // ];
            //
            // // var accs = await web3.eth.getAccounts();
            // // console.log("accs", accs);
            // // const balance = await web3.eth.getBalance(accounts[0]);
            // const tokenInst = new web3.eth.Contract(tokenABI, '0xB8c77482e45F1F44dE1745F52C74426C631bDD52'); //BNB
            // console.log("tokenInst", tokenInst);
            // const balance = await tokenInst.methods.balanceOf(accounts[0]).call();
            //
            // console.log("balance", balance);
            // setBalance(balance);
            // // getAccounts().then(value => console.log(value));


            ///

            // let accs = await web3.eth.getAccounts();
            //
            // const newAccounts = await Promise.all(accs.map(async (address) => {
            //     const balance = await web3.eth.getBalance(address)
            //
            //     const tokenBalances = await Promise.all(tokenAddresses.map(async (token) => {
            //
            //         const tokenInst = new web3.eth.Contract(tokenABI, token.address);
            //
            //         const balance = await tokenInst.methods.balanceOf(address).call()
            //
            //         return {
            //             token: token.token,
            //             balance
            //         }
            //     }))
            //
            //     return {
            //         address,
            //         balance: web3.utils.fromWei(balance, 'ether'),
            //         tokens: tokenBalances
            //     }
            // }))
            // console.log("newAccounts");
            // console.log(newAccounts);
            ///

            const BNB = new Web3(`${process.env.REACT_APP_TRALE_CONTRACT_URL}`);
            const abi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
            const address = `${process.env.REACT_APP_TRALE_ADDRESS}`;
            const myContractInstance = new BNB.eth.Contract(abi, address);
            //ethcall2('balanceOf', 'input_2','myanswer_2','uint256', '|uint256', 'btn_2');
            // data-grp="g2"
            // data-type="address"
            //function ethcall2(strMethodName, strInputElementName, strOutputElementName, strOutputtype, strOutputFieldNames, strBtnName) {
            let result;
            console.log("result");
            myContractInstance.methods.balanceOf(acc[0])
                .call({from: '0x0000000000000000000000000000000000000000'}, function (err, res) {
                    if (err) {
                        result = err;
                        console.log(result);
                        setBalance("0");
                    } else {
                        result = res;
                        console.log(result)
                        // console.log(BNB.utils.fromWei(result, "ether" ));
                        setBalance(new Intl.NumberFormat().format(Number(BNB.utils.fromWei(result, "ether" ))));
                    }
                });

        } catch (error) {
            console.error(error);
        }
    };

    //This will start the onboarding proccess
    const onClickInstall = () => {
        const forwarderOrigin = window.location.href;
        //We create a new MetaMask onboarding object to use in our app
        const onboarding = new MetaMaskOnboarding({ forwarderOrigin });
        //On this object we have startOnboarding which will start the onboarding process for our end user
        onboarding.startOnboarding();
    };

    const getAccounts = async () => {
        let getAccountsResults = document.getElementById('getAccountsResult');
        try {
            const _accounts = await ethereum.request({
                method: 'eth_accounts',
            })
            getAccountsResults.innerHTML = _accounts[0] || 'Not able to get accounts'
        } catch (err) {
            console.error(err)
            getAccountsResults.innerHTML = `Error: ${err.message}`
        }
    }

    const sendToken = async () => {
//         let minABI = [
// // transfer
//             {
//                 "constant": false,
//                 "inputs": [
//                     {
//                         "name": "_to",
//                         "type": "address"
//                     },
//                     {
//                         "name": "_value",
//                         "type": "uint256"
//                     }
//                 ],
//                 "name": "transfer",
//                 "outputs": [
//                     {
//                         "name": "success",
//                         "type": "bool"
//                     }
//                 ],
//                 "payable": false,
//                 "stateMutability": "nonpayable",
//                 "type": "function"
//             }
//         ];
//         const contractAddr = `${process.env.REACT_APP_TRALE_ADDRESS}`;
//         web3 = new Web3(window.ethereum);
//         let contract = await new web3.eth.Contract(minABI, contractAddr);
// console.log("sendToken",accounts[0]);
//         contract.methods.transfer(`${process.env.REACT_APP_PAY_TO_ADDRESS}`, 5).send({
//             from: accounts[0]
//         });
//

        var BNB = new Web3(`${process.env.REACT_APP_TRALE_CONTRACT_URL}`);
        var abi = [{"inputs":[],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"spender","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"constant":true,"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"spender","type":"address"}],"name":"allowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"approve","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"account","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"internalType":"uint8","name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"getOwner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"spender","type":"address"},{"internalType":"uint256","name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"mint","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[],"name":"renounceOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transfer","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"sender","type":"address"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"transferFrom","outputs":[{"internalType":"bool","name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}];
        var tokenAddress = `${process.env.REACT_APP_TRALE_ADDRESS}`;
        const fromAddress = accounts[0];
        const toAddress = `${process.env.REACT_APP_PAY_TO_ADDRESS}`;
        //`${process.env.REACT_APP_AVATAR_URL}/${props.username}/avatar-${props.username}.png`
        var myContractInstance = new BNB.eth.Contract(abi, tokenAddress, {
            from: fromAddress
        });
        //ethcall2('balanceOf', 'input_2','myanswer_2','uint256', '|uint256', 'btn_2');
        // data-grp="g2"
        // data-type="address"
        //function ethcall2(strMethodName, strInputElementName, strOutputElementName, strOutputtype, strOutputFieldNames, strBtnName) {
        // .call({from: '0x0000000000000000000000000000000000000000'}, function (err, res) {
        var result;
        console.log("result2");
        // let decimals = web3.utils.toBN(18);
        // let amount = web3.utils.toBN(5);
        // let value = amount.mul(web3.utils.toBN(10).pow(decimals));
        // myContractInstance.methods.transfer(`${process.env.REACT_APP_PAY_TO_ADDRESS}`, value)
        //     .send({from: fromAddress}).then( function (err, res) {
        //
        //
        //     if (err) {
        //         result = err;
        //         console.log(result);
        //     } else {
        //         result = res;
        //         console.log(result);
        //
        //     }
        // });

        const amount = 5;
        const tx = {
            from: fromAddress,
            to: toAddress,
            data: myContractInstance.methods.transfer(toAddress, BNB.utils.toWei(amount.toString())).encodeABI(),
            gas: 21000,
        }
        BNB.eth.sendTransaction(tx).then(res => {
            console.log("res", res)
        }).catch(err => {
            console.log("err", err)
        });

    }


    return (
        <>
            <div className="tw-flex tw-flex-wrap">
                <div className="tw-w-full">
                    <div className="tw-relative tw-inline-flex tw-align-middle tw-w-full tw-space-x-8">
                        <div className="tw-inline-block tw-flex tw-items-center">
                            <img src="/favicon.svg" className="tw-w-7 tw-inline-block tw-align-middle" />
                            {/*<span id="getAccountsResult"></span>*/}
                            <span className="tw-text-primary-light dark:tw-text-primary-lighter">{balance}</span>
                        </div>
                        {/*<button*/}
                        {/*    onClick={sendToken}*/}
                        {/*    id="sendEthereumButton"*/}
                        {/*    className="tw-ml-4 tw-flex tw-items-center tw-px-4 tw-py-2 tw-font-medium tw-text-center*/}
                        {/*    tw-text-white tw-transition-colors tw-duration-200 tw-rounded-3xl tw-bg-gradient-blue-purple dark:tw-bg-gradient-blue-light*/}
                        {/*    hover:tw-filter hover:tw-drop-shadow-blue-dark focus:tw-outline-none disabled:tw-opacity-50"*/}
                        {/*>*/}
                        {/*    Send*/}
                        {/*</button>*/}
                        <button
                            onClick={connectToMetaMask}
                            id="connectEthereumButton"
                            className="tw-ml-4 tw-flex tw-items-center tw-px-4 tw-py-2 tw-font-medium tw-text-center
                            tw-text-white tw-transition-colors tw-duration-200 tw-rounded-3xl tw-bg-gradient-blue-purple dark:tw-bg-gradient-blue-light
                            hover:tw-filter hover:tw-drop-shadow-blue-dark focus:tw-outline-none disabled:tw-opacity-50"
                            disabled={metamaskTxt === "Connected" ? true : false}
                        >
                            {metamaskTxt}
                        </button>
                        <button
                            ref={btnDropdownRef}
                            onClick={handleDropdownClick}
                            type="button"
                            aria-haspopup="true"
                            className="tw-transition-opacity tw-duration-200 tw-rounded-full dark:tw-opacity-75 dark:hover:tw-opacity-100 focus:tw-outline-none focus:tw-ring dark:focus:tw-opacity-100"
                        >
                            <span className="tw-sr-only">Open Profile Menu</span>
                            {props.avatar ?
                                <img className="tw-w-10 tw-h-10 tw-rounded-full" src={`${process.env.REACT_APP_AVATAR_URL}/${props.avatar}`} />
                                : <div
                                    className="tw-p-2 tw-transition-colors tw-duration-200 tw-rounded-full tw-text-primary-lighter tw-bg-primary-50
                                    hover:tw-text-primary hover:tw-bg-primary-100 dark:hover:tw-text-light dark:hover:tw-bg-primary-dark dark:tw-bg-dark focus:tw-outline-none focus:tw-bg-primary-100 dark:tw-focus:tw-bg-primary-dark focus:tw-ring-primary-darker">
                                    <FiUser
                                        className="tw-w-7 tw-h-7 tw-rounded-full tw-text-primary-lighter hover:tw-text-primary" />
                                </div>
                            }

                        </button>

                        <div
                            ref={popoverDropdownRef}
                            className={
                                (dropdownPopoverShow ? "tw-block " : "tw-hidden ") +
                                "tw-z-200 tw-absolute tw-right-0 tw-w-48 tw-py-1 tw-bg-white tw-rounded-md shadow-lg tw-top-12 tw-ring-1 tw-ring-black tw-ring-opacity-5 dark:tw-bg-dark focus:tw-outline-none"
                            }
                            tabIndex="-1"
                            role="menu"
                            aria-orientation="vertical"
                            aria-label="User menu"
                            {...attributes.popper}
                        >
                            {/*<NavLink to="/wallet">*/}
                            {/*    <div*/}
                            {/*        role="menuitem"*/}
                            {/*        className="tw-block tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 tw-transition-colors hover:tw-bg-gray-100 dark:tw-text-light dark:hover:tw-bg-primary"*/}
                            {/*    >*/}
                            {/*        Wallet*/}
                            {/*    </div>*/}
                            {/*</NavLink>*/}
                            <NavLink to="/settings">
                                <div
                                    role="menuitem"
                                    className="tw-block tw-px-4 tw-py-2 tw-text-sm tw-text-gray-700 tw-transition-colors hover:tw-bg-gray-100 dark:tw-text-light dark:hover:tw-bg-primary"
                                >
                                    Settings
                                </div>
                            </NavLink>
                            <SignOut />
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default function ProfileRender(props) {
    return (
        <>
            <Profile {...props}/>
        </>
    );
}